import React, { useEffect } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
function FeeStructure() {
  useEffect(() => {
    document.title = "Staff Members-  CARMEL CONVENT SCHOOL, DHARUHERA";
  }, []);
  return (
    <>
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li>
                  <Link to="/"> Home </Link>
                </li>
                <li>Academics</li>
                <li>Fee Structure</li>
              </ul>
            </div>
            <div className="col-lg-12">
              <h2 className="innerheading">Fee Structure</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div class="table-responsive maintable">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Class</th>
                      <th>Registration Fee</th>
                      <th>Composite Fee (Monthly)</th>
                      <th>Admission Fee ( For New Student)</th>
                      <th>Yearly</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Nur. - U.KG </td>
                      <td>200 </td>
                      <td>4200 </td>
                      <td>10000 </td>

                      <td>60600</td>
                    </tr>
                    <tr>
                      <td>I - V </td>
                      <td>200 </td>
                      <td>4700 </td>
                      <td>10000 </td>
                      <td>66600 </td>
                    </tr>
                    <tr>
                      <td>VI </td>
                      <td>200 </td>
                      <td>5000 </td>
                      <td>10000 </td>
                      <td>70200 </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default FeeStructure;
